import { gql } from '@apollo/client';

export const CHECK_HAS_ACCESS_TO_STORYBOARD_IMAGE_GENERATION_FEATURE = gql`
  query CHECK_HAS_ACCESS_TO_STORYBOARD_IMAGE_GENERATION_FEATURE {
    checkHasAccessToStoryboardImageGenerationFeature {
      access
    }
  }
`;
